// Main Scripts
// ---------------------
import mainSlideshow from './js/widgets/mainSlideshow.js';
import hotButtons from './js/widgets/hotButtons.js';
import seoWidget from './js/widgets/seoWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import staticManagedSponsors from './js/widgets/staticManagedSponsors.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Secondary Scripts
// --------------------
import './js/localjs.js';

$(document).ready(function () {
  if (window.location.pathname === '/') {
    mainSlideshow();
    hotButtons();
    seoWidget();
    multiScheduleFeature();
    staticManagedSponsors();
    scrollerSponsors();
  }
});
